export const profilePage = {
    'profile.page.title': '{name} | Профиль',
    'profile.page.title.my': 'Мой Профиль | R.Toys',
    'profile.page.description': 'Взгляните на профиль пользователя {shortId}: его уникальные коллекции NFT и физических игрушек свидетельствуют о его увлечениях.',
    'profile.page.description.my': 'Ваше пространство в R.Toys! Управляйте своими коллекциями NFT и физических игрушек, обновляйте свой профиль и открывайте новые увлечения..',
}
